/*
 * Empty cart recommendations (sections/cart-drawer.liquid, <empty-cart-recs>).
 * - Stays hidden until it has product cards (recently viewed ones arrive via fetch).
 * - Fills ||discount|| in the banner with the biggest real discount among the cards.
 * - Counts down to the sale end date set in the theme editor; no date, no countdown.
 */

(function() {
  if (customElements.get('empty-cart-recs')) return;

  const pad = (value) => String(value).padStart(2, '0');

  class EmptyCartRecs extends HTMLElement {
    constructor() {
      super();
      this.onListLoaded = this.refresh.bind(this);
    }

    connectedCallback() {
      this.list = this.querySelector('recently-viewed');
      this.list?.addEventListener('theme:recently-viewed:loaded', this.onListLoaded);
      this.refresh();
      this.startTimer();
    }

    disconnectedCallback() {
      this.list?.removeEventListener('theme:recently-viewed:loaded', this.onListLoaded);
      clearInterval(this.timer);
    }

    refresh() {
      const cards = Array.from(this.querySelectorAll('[data-discount-percent]'));
      this.hidden = cards.length === 0;

      const banner = this.querySelector('[data-recs-banner]');
      if (!banner) return;

      const template = banner.dataset.template || '';
      const maxDiscount = Math.max(0, ...cards.map((card) => parseInt(card.dataset.discountPercent, 10) || 0));
      const needsDiscount = template.includes('||discount||');
      const text = banner.querySelector('[data-recs-banner-text]');

      banner.hidden = !template || (needsDiscount && maxDiscount === 0);
      if (text) text.textContent = template.replace(/\|\|discount\|\|/g, `${maxDiscount}%`);
    }

    startTimer() {
      const timer = this.querySelector('[data-recs-timer]');
      const time = timer?.querySelector('[data-recs-time]');
      const end = parseInt(this.dataset.saleEnd, 10) * 1000;
      if (!timer || !time || !end) return;

      const tick = () => {
        const left = Math.floor((end - Date.now()) / 1000);

        if (left <= 0) {
          timer.hidden = true;
          clearInterval(this.timer);
          return;
        }

        const days = Math.floor(left / 86400);
        const hours = Math.floor((left % 86400) / 3600);
        const minutes = Math.floor((left % 3600) / 60);
        const seconds = left % 60;

        time.textContent = `${days ? `${days}d ` : ''}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        timer.hidden = false;
      };

      tick();
      this.timer = setInterval(tick, 1000);
    }
  }

  customElements.define('empty-cart-recs', EmptyCartRecs);
})();
